/** The till's cash drawer, day by day. */
const cash = {
  en: {
    title: "Cash drawer",
    subtitle: "Every day the drawer was open: what it held, what was counted, what went home and what stayed. Both counts are blind at the till.",
    loadFailed: "Could not load the drawer's history.",
    none: "The drawer has not been opened yet.",
    openNow: "open now",
    openedBy: "Opened by {name} with {amount}",
    expectedWas: "expected {amount}",
    closedBy: "Closed by {name}, {time}",
    expected: "Expected",
    counted: "Counted",
    difference: "Difference",
    takenHome: "Taken / left",
    takenAndLeft: "{taken} / {left}",
    showMovements: "What went in and out",
    hideMovements: "Hide",
  },
  fr: {
    title: "Tiroir-caisse",
    subtitle: "Chaque jour d'ouverture : ce que le tiroir contenait, ce qui a été compté, emporté et laissé. Les deux comptages sont à l'aveugle en caisse.",
    loadFailed: "Impossible de charger l'historique du tiroir.",
    none: "Le tiroir n'a pas encore été ouvert.",
    openNow: "ouvert",
    openedBy: "Ouvert par {name} avec {amount}",
    expectedWas: "attendu {amount}",
    closedBy: "Fermé par {name}, {time}",
    expected: "Attendu",
    counted: "Compté",
    difference: "Écart",
    takenHome: "Emporté / laissé",
    takenAndLeft: "{taken} / {left}",
    showMovements: "Entrées et sorties",
    hideMovements: "Masquer",
  },
  ar: {
    title: "درج النقود",
    subtitle: "كل يوم فُتح فيه الدرج: ما احتواه، وما عُدّ، وما أُخذ وما بقي. العدّ في الصندوق يتم دون معرفة المبلغ المتوقع.",
    loadFailed: "تعذّر تحميل سجل الدرج.",
    none: "لم يُفتح الدرج بعد.",
    openNow: "مفتوح الآن",
    openedBy: "فتحه {name} بمبلغ {amount}",
    expectedWas: "المتوقع {amount}",
    closedBy: "أغلقه {name}، {time}",
    expected: "المتوقع",
    counted: "المعدود",
    difference: "الفرق",
    takenHome: "المأخوذ / المتبقي",
    takenAndLeft: "{taken} / {left}",
    showMovements: "الداخل والخارج",
    hideMovements: "إخفاء",
  },
};

export default cash;
